export default {
	'bold': 'Gras',
	'italic': 'Italique',
	'underline': 'Souligné',
	'strike': 'Barré',
	'unordered': 'Liste non ordonnée',
	'ordered': 'Liste ordonnée',
	'outdent': 'Diminuer le retrait',
	'indent': 'Augmenter le retrait',
	'h1': 'Titre 1',
	'h2': 'Titre 2',
	'h3': 'Titre 3',
	'h4': 'Titre 4',
	'h5': 'Titre 5',
	'h6': 'Titre 6',
	'quote': 'Citation',
	'hardBreak': 'Saut de ligne',
	'hr': 'Règle horizontale',
	'left': 'Aligner à gauche',
	'center': 'Centrer',
	'right': 'Aligner à droite',
	'justify': 'Justifier',
	'link': 'Lien',
	'unlink': 'Supprimer le lien',
	'superscript': 'Exposant',
	'subscript': 'Indice',
	'removeFormat': 'Supprimer le formatage',
	'undo': 'Annuler',
	'redo': 'Rétablir',
	'viewsource': 'Voir la source',
	'infoBlock': 'Information',
};
